import { FileTypeIconMap, FileTypeIconSize, getFileTypeIconProps } from '@fluentui/react-file-type-icons';

export type { FileTypeIconSize };

export interface IconProps {
  readonly iconName: string;
}

export const getFileIconProps: (fileType: string, size?: FileTypeIconSize) => IconProps = (fileType, size = 96) => {
  const fileTypeObject = FileTypeIconMap[fileType];

  if (fileTypeObject && fileTypeObject.extensions) {
    const extension = fileTypeObject.extensions[0];

    return getFileTypeIconProps({ extension, size });
  }

  return getFileTypeIconProps({ extension: 'genericfile', size });
};
